import lax from 'lax.js'

export default class IntroHome {

    static get selector() {
        return '.introHome';
    }

    constructor(el) {

        this.el = el;


        lax.init()

        // Add a driver that we use to control our animations
        lax.addDriver('scrollY', function () {
            return window.scrollY
        })

        // Add animation bindings to elements
        lax.addElements('.expertiseHome__galleryItem--1', {
        scrollY: {
            translateY: [
                ["elInY", "elOutY"],
                [0, 100],
            ]
        }
        });

        lax.addElements('.expertiseHome__galleryItem--2', {
            scrollY: {
                translateY: [
                    ["elInY", "elOutY"],
                    [-100, +70],
                ]
            }
            });

        lax.addElements('.introHome__image img', {
            scrollY: {
                translateY: [
                    ['elInY',"elOutY"],
                    ['elWidth/-1440*335', 0],
                ]
            }
            })

        this.setEvents();
    }

      /**
     * Events
     */
    
    setEvents() {

    }


}